<template>
  <v-tailwind-modal v-model="pa_modalshow" @confirm="pa_confirm" @cancel="cancel">
    <template v-slot:title>{{ $t('setpublic.editpublic') }}</template>
    <template v-slot:icon><!-- Edit - Fill: 1 Weight: 400 Grade: 0 Optical Size: 48 -->
      <svg class="text-skin-b-list-mute" fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
        <path d="M794 390 666 262l42-42q17-17 42.5-16.5T793 221l43 43q17 17 17 42t-17 42l-42 42Zm-42 42L248 936H120V808l504-504 128 128Z"/>
      </svg>
    </template>
    <div class="grid gap-4 sm:grid-cols-2">
      <div class="form-group mb-2">
        <label class="font-medium text-sm text-skin-b-list-mute" for="Überschrift">{{ $t('setpublic.headline') }}</label>
        <input v-model="pa_headline" type="text" class="form-control
                block w-full px-3 py-2 rounded-lg 
                font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                border-2 border-skin-b-list-bord 
                hover:bg-skin-b-list-head
                focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                " ref="Überschrift" id="Überschrift" aria-describedby="Überschrift" 
                :placeholder="$t('setpublic.headlineph')">
      </div>
      <div class="form-group mb-2">     
                <label class="font-medium text-sm text-skin-b-list-mute" for="pubAccessSchema">{{ $t('setpublic.scheme') }}</label>
                <div class="relative w-full inline-flex self-center">
                      <svg v-if="pa_schema=='bright'" class="h-12 w-10 absolute ml-2 top-0 right-2 pointer-events-none p-2 text-skin-b-list-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                        <path d="M479.765-340Q538-340 579-380.765q41-40.764 41-99Q620-538 579.235-579q-40.764-41-99-41Q422-620 381-579.235q-41 40.764-41 99Q340-422 380.765-381q40.764 41 99 41Zm.235 60q-83 0-141.5-58.5T280-480q0-83 58.5-141.5T480-680q83 0 141.5 58.5T680-480q0 83-58.5 141.5T480-280ZM70-450q-12.75 0-21.375-8.675Q40-467.351 40-480.175 40-493 48.625-501.5T70-510h100q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T170-450H70Zm720 0q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T790-510h100q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T890-450H790ZM479.825-760Q467-760 458.5-768.625T450-790v-100q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T510-890v100q0 12.75-8.675 21.375-8.676 8.625-21.5 8.625Zm0 720Q467-40 458.5-48.625T450-70v-100q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T510-170v100q0 12.75-8.675 21.375Q492.649-40 479.825-40ZM240-678l-57-56q-9-9-8.629-21.603.37-12.604 8.526-21.5 8.896-8.897 21.5-8.897Q217-786 226-777l56 57q8 9 8 21t-8 20.5q-8 8.5-20.5 8.5t-21.5-8Zm494 495-56-57q-8-9-8-21.375T678.5-282q8.5-9 20.5-9t21 9l57 56q9 9 8.629 21.603-.37 12.604-8.526 21.5-8.896 8.897-21.5 8.897Q743-174 734-183Zm-56-495q-9-9-9-21t9-21l56-57q9-9 21.603-8.629 12.604.37 21.5 8.526 8.897 8.896 8.897 21.5Q786-743 777-734l-57 56q-8 8-20.364 8-12.363 0-21.636-8ZM182.897-182.897q-8.897-8.896-8.897-21.5Q174-217 183-226l57-56q8.8-9 20.9-9 12.1 0 20.709 9Q291-273 291-261t-9 21l-56 57q-9 9-21.603 8.629-12.604-.37-21.5-8.526ZM480-480Z"/>
                      </svg>
                      <svg v-if="pa_schema=='dark'" class="h-12 w-10 absolute ml-2 top-0 right-2 pointer-events-none p-2 text-skin-b-list-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                        <path d="M480-120q-150 0-255-105T120-480q0-150 105-255t255-105q8 0 17 .5t23 1.5q-36 32-56 79t-20 99q0 90 63 153t153 63q52 0 99-18.5t79-51.5q1 12 1.5 19.5t.5 14.5q0 150-105 255T480-120Zm0-60q109 0 190-67.5T771-406q-25 11-53.667 16.5Q688.667-384 660-384q-114.689 0-195.345-80.655Q384-545.311 384-660q0-24 5-51.5t18-62.5q-98 27-162.5 109.5T180-480q0 125 87.5 212.5T480-180Zm-4-297Z"/>
                      </svg>
                      <select name="pubAccessSchema" id="pubAccessSchema" 
                      v-model="pa_schema"
                      class="w-full h-12 pl-4 pr-12 appearance-none truncate
                      rounded-lg cursor-pointer disabled:cursor-default border-2 border-skin-b-list-bord
                      font-semibold text-lg text-skin-b-list-base
                      bg-skin-b-list-back
                      hover:bg-skin-b-list-head 
                      focus:outline-none focus:ring-0
                      transition duration-150 ease-in-out">
                      <option value="bright">{{ $t('setpublic.schemebright') }}</option>
                      <option value="dark">{{ $t('setpublic.schemedark') }}</option>
                      </select>  
                </div>
      </div>
      <div class="form-group mb-4">
        <label class="font-medium text-sm text-skin-b-list-mute">{{ $t('setpublic.logo') }}</label>
        <div v-if="pa_logo!=''" class="max-w-[20%] min-w-[4rem] h-16 my-2">
          <img id="logoimgid" class="max-h-16" :src="'https://'+this.$store.state.WbIp+'/wallbox'+pa_logo.substring(1)" alt="" />          
        </div>
        <div v-if="pa_logo==''" class="max-w-[20%] min-w-[4rem] h-16 my-2">
          <img class="max-h-16" src="../assets/Logo_Kathrein_rot_rgb_kombi.svg" alt="" />          
        </div>        
        <div class="flex items-center justify-center w-full">
                <label for="inputlogofile" 
                class="flex flex-col items-center justify-center w-full px-4 py-2 sm:h-12 mt-2
                        rounded-lg border-2 border-transparent
                        font-semibold text-lg text-skin-b-invt 
                        bg-skin-active128
                        disabled:opacity-50 disabled:hover:bg-skin-active128 
                        hover:bg-skin-active96
                        focus:bg-skin-active128 focus:outline-none focus:ring-0 
                        active:bg-skin-active128 
                        transition duration-300 ease-in-out">
                    <div class="flex flex-col items-center justify-center">
                        <p class="font-semibold text-lg text-skin-b-invt">{{ $t('setpublic.chooselogo') }} <span class="text-xs">(JPG/PNG/SVG)</span></p>
                    </div>
                    <input id="inputlogofile" type="file" ref="logofile" @change="LogoFileUpload()" class="hidden" />
                </label>
          </div>

          <div class="my-6 flex" v-if="logofile!=''">
              <div>
                <svg v-if="logouploadstatus=='ready'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path fill=rgb(var(--color-text-b-list-base)) d="M220 896q-24 0-42-18t-18-42V693h60v143h520V693h60v143q0 24-18 42t-42 18H220Zm230-153V372L330 492l-43-43 193-193 193 193-43 43-120-120v371h-60Z"/>
                </svg>
                <svg v-if="logouploadstatus=='loading'" class="spinner m-2" width="32" height="32" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="45"/>
                </svg>
                <svg v-if="logouploadstatus=='done'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path fill=rgb(var(--color-text-b-list-base)) d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z"/>
                </svg>
              </div>
              <div class="ml-2">
                <span class="font-bold text-xl text-skin-b-list-base">{{ logofilename }}</span>
                <span class="text-skin-b-list-base"> ({{ logofilesize }} KB)</span>
                <p class="mt-1 text-xs text-skin-b-list-mute dark:text-gray-400">{{ $t('setpublic.lastchanged', {date:logofiledate}) }}</p>                
              </div>
          </div>
          <button v-if="this.logofile!=''" :disabled="this.logofile==''" 
            class="px-4 py-2 h-12 w-full
            rounded-lg border-2 border-transparent
            font-semibold text-lg text-skin-b-invt 
            bg-skin-active128
            disabled:opacity-50 disabled:hover:bg-skin-active128 
            hover:bg-skin-active96
            focus:bg-skin-active128 focus:outline-none focus:ring-0 
            active:bg-skin-active128 
            transition duration-300 ease-in-out"
            @click.prevent="submitForm" @click="UploadLogo(pa_id)">{{ $t('setpublic.uploadlogo') }}</button> 
      </div>
      <div class="form-group mb-4">
        <label class="font-medium text-sm text-skin-b-list-mute">{{ $t('setpublic.back') }}</label>
        <div v-if="pa_background!=''" class="max-w-[20%] min-w-[4rem] h-16 my-2">
          <img id="backimgid" class="max-h-16" :src="'https://'+this.$store.state.WbIp+'/wallbox'+pa_background.substring(1)" alt="" />          
        </div>
        <div v-if="pa_background==''" class="max-w-[20%] min-w-[4rem] h-16 my-2">
          <img class="max-h-16" src="../assets/WB_back.jpg" alt="" />          
        </div>
        <div class="flex items-center justify-center w-full">
                <label for="inputbackfile" 
                class="flex flex-col items-center justify-center w-full px-4 py-2 sm:h-12 mt-2
                        rounded-lg border-2 border-transparent
                        font-semibold text-lg text-skin-b-invt 
                        bg-skin-active128
                        disabled:opacity-50 disabled:hover:bg-skin-active128 
                        hover:bg-skin-active96
                        focus:bg-skin-active128 focus:outline-none focus:ring-0 
                        active:bg-skin-active128 
                        transition duration-300 ease-in-out">
                    <div class="flex flex-col items-center justify-center">
                        <p class="font-semibold text-lg text-skin-b-invt">{{ $t('setpublic.chooseback') }} <span class="text-xs">(JPG/PNG/SVG)</span></p>
                    </div>
                    <input id="inputbackfile" type="file" ref="backfile" @change="BackFileUpload()" class="hidden" />
                </label>
          </div>
          <div class="my-6 flex" v-if="backfile!=''">
              <div>
                <svg v-if="backuploadstatus=='ready'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path fill=rgb(var(--color-text-b-list-base)) d="M220 896q-24 0-42-18t-18-42V693h60v143h520V693h60v143q0 24-18 42t-42 18H220Zm230-153V372L330 492l-43-43 193-193 193 193-43 43-120-120v371h-60Z"/>
                </svg>
                <svg v-if="backuploadstatus=='loading'" class="spinner m-2" width="32" height="32" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="50" cy="50" r="45"/>
                </svg>
                <svg v-if="backuploadstatus=='done'" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 96 960 960" width="48">
                  <path fill=rgb(var(--color-text-b-list-base)) d="M378 810 154 586l43-43 181 181 384-384 43 43-427 427Z"/>
                </svg>
              </div>
              <div class="ml-2">
                <span class="font-bold text-xl text-skin-b-list-base">{{ backfilename }}</span>
                <span class="text-skin-b-list-base"> ({{ backfilesize }} KB)</span>
                <p class="mt-1 text-xs text-skin-b-list-mute dark:text-gray-400">{{ $t('setpublic.lastchanged', {date:backfiledate}) }}</p>                
              </div>
          </div>
          <button v-if="this.backfile!=''" :disabled="this.backfile==''" 
            class="px-4 py-2 h-12 w-full
            rounded-lg border-2 border-transparent
            font-semibold text-lg text-skin-b-invt 
            bg-skin-active128
            disabled:opacity-50 disabled:hover:bg-skin-active128 
            hover:bg-skin-active96
            focus:bg-skin-active128 focus:outline-none focus:ring-0 
            active:bg-skin-active128 
            transition duration-300 ease-in-out"
            @click.prevent="submitForm" @click="UploadBack(pa_id)">{{ $t('setpublic.uploadback') }}</button> 
      </div>
 

    </div>
  </v-tailwind-modal>

  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />

  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('settings.public')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconPublicShare             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
        <template v-slot:formgrid>


          <div class="mt-2 mb-2 sm:col-span-2">
            <ToggleWithLabel 
                v-model="pubAccess"
                @update:model-value="SwitchPubAccess()"
                :label="$t('setpublic.publiconoff')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
            />
          </div>

          <div class="form-group mb-2 sm:col-span-2">
            <TextfieldWithLabel
              :text="$t('setpublic.publichelp')"
            />       
          </div>

          <div class="form-group mb-2 sm:col-span-2">
          <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setpublic.publicaccess') }}</div>           
          </div>

          <div class="form-group mb-6 sm:col-span-2 overflow-x-scroll no-scrollbar">
            <table class="table-auto w-full p-2">
              <thead>
                <tr class="text-left">
                  <th>{{ $t('setpublic.headline') }}</th>
                  <th>{{ $t('setpublic.schemeshort') }}</th>
                  <th>{{ $t('setpublic.logo') }}</th>
                  <th>{{ $t('setpublic.back') }}</th>
                  <th>{{ $t('common.link') }}</th>
                  <th class="text-right">{{ $t('common.edit') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="" v-for="(approval, index) in pubAccessTable" :key="index">
                  <td>{{ this.decodeHtml(approval.headline) }}</td>
                  <td v-if="approval.schema=='bright'">{{ $t('setpublic.schemebright') }}</td>
                  <td v-if="approval.schema=='dark'">{{ $t('setpublic.schemedark') }}</td>
                  <td v-if="approval.schema==''">{{ $t('setpublic.schemenotset') }}</td>
                  <td v-if="approval.logo!=''">
                    <div class="max-w-[4rem] min-w-[1rem] my-2">
                      <img class="max-h-8" :src="'https://'+this.$store.state.WbIp+'/wallbox'+approval.logo.substring(1)" alt="" />          
                    </div>
                  </td>
                  <td v-if="approval.logo==''">
                    <div class="max-w-[4rem] min-w-[1rem] my-2">
                      <img class="max-h-8" src="../assets/Logo_Kathrein_rot_rgb_kombi.svg" alt="" />          
                    </div>
                  </td>
                  <td v-if="approval.background!=''">
                    <div class="max-w-[6rem] min-w-[2rem] my-2">
                      <img class="max-h-8" :src="'https://'+this.$store.state.WbIp+'/wallbox'+approval.background.substring(1)" alt="" />          
                    </div>                  
                  </td>
                  <td v-if="approval.background==''">
                    <div class="max-w-[6rem] min-w-[2rem] my-2">
                      <img class="max-h-8" src="../assets/WB_back.jpg" alt="" />          
                    </div>
                  </td>
                  <td>
                    <a :href="'https://'+this.$store.state.WbIp+'/#/Mesh?headline='+this.decodeHtml(approval.headline)+'&schema='+approval.schema+'&ip=https://'+this.$store.state.WbIp+'&logo='+approval.logo.substring(1)+'&background='+approval.background.substring(1)+'&pubtoken='+approval.token" target="_blank" rel="noopener noreferrer"
                    class="inline-flex items-center px-2 py-1 text-sm font-medium rounded-md
                          text-skin-b-list-base bg-skin-b-list-back border-2 border-skin-b-list-bord 
                          hover:text-skin-b-base hover:bg-skin-b-back  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="w-5 h-5 fill-current" fill="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg">
                            <path d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h279v60H180v600h600v-279h60v279q0 24-18 42t-42 18H180Zm202-219-42-43 398-398H519v-60h321v321h-60v-218L382-339Z"/>
                          </svg>
                    </a>
                  </td>
                  <td class="text-right">
                    <button @click="delPubAccess(approval.id)"
                          type="button" class="inline-flex items-center px-2 py-1 text-sm font-medium 
                          text-skin-b-list-base bg-skin-b-list-back border-l-2 border-y-2 border-skin-b-list-bord rounded-l-md
                          hover:text-red-800 hover:bg-red-100  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="w-5 h-5 fill-current" fill="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                              <path d="m376-300 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 180q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520Zm-400 0v520-520Z"/>
                          </svg>                          
                          </button>
                          <button type="button" @click="pa_id=approval.id;pa_headline=this.decodeHtml(approval.headline);pa_schema=approval.schema;pa_logo=approval.logo;pa_background=approval.background;pa_modalshow = true;" 
                          class="inline-flex items-center px-2 py-1 text-sm font-medium rounded-r-md
                          text-skin-b-list-base bg-skin-b-list-back border-2 border-skin-b-list-bord 
                          hover:text-skin-b-base hover:bg-skin-b-back  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="w-5 h-5 fill-current" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="m16.188 7.542-3.73-3.73 1.021-1.02q.521-.521 1.24-.521t1.239.521l1.25 1.25q.5.5.5 1.239 0 .74-.5 1.24Zm-1.23 1.229L6.229 17.5H2.5v-3.729l8.729-8.729Z"/>
                          </svg>
                          </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

      </template>
      <template v-slot:formbottom>
        <ActionButton @click="addPubAccess()">
          {{ $t('setpublic.newpublicaccess') }}
        </ActionButton>
      </template>
    </SettingsBody>
</SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconPublicShare from './icons/IconPublicShare.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
export default {
  components: {
    SrcBackgroundScroll, HeadlineSubScroll, IconPublicShare,
    SettingsHeader, SettingsBody, ActionButton,
    ToggleWithLabel, TextfieldWithLabel
  },  
  data() {
    return {
          isLoading: false,
          pubAccess: this.$store.state.WbPubAccess,
          pubAccessTable: [],
          logourl: 'Logo_Kathrein_rot.svg',
          backurl: 'WB_back.jpg',
          pa_modalshow: false,
          pa_id: '',
          pa_headline: '',
          pa_schema: '',
          pa_logo: '',
          pa_background: '',
          logofile: '',
          backfile: '',
          logofilename: '',
          backfilename: '',
          logofiletype: '',
          backfiletype: '',
          logofilesize: '',
          logofiledate: '',
          backfilesize: '',
          backfiledate: '',
          logouploadstatus: 'ready',
          backuploadstatus: 'ready',
          downloadstatus: 'ready',
          swversions: [],
          otiinfo: '',
          counter: 200,
          isShrunk: false,
    }
  },
  computed: {
  },
  methods: {
    restarttimer() {
        this.interval = setInterval(() => {
          if (this.counter === 0) {
            clearInterval(this.interval);
            this.$router.push({path: '/'});               
          } else {
            this.counter--
          }             
        }, 1000)
    },
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    getlogoUrl() {
      console.log(this.logourl);
        return require('../assets/'+this.logourl)
    },
    SwitchPubAccess(){
      let lvPubAccess = 0;
        if(this.pubAccess){
          this.$store.commit('setPubAccess', true );
          lvPubAccess = 1;
        }
        else{
          this.$store.commit('setPubAccess', false );
          lvPubAccess = 0;
        }               
        this.axios
        .get('wallbox/settings.php?action=enable_public_access&enabled='+lvPubAccess+'&user='+this.$store.state.token)
        .then((response) => {         
                    if(response.data.status=='ok'){
                      console.log('Switch PublicAccess: '+this.pubAccess+' Store PublicAccess: '+this.$store.state.WbPubAccess);
                    }else{
                      console.log('Error Switch Public Access Toggle');                   
                    }
                  })
        .catch((errors) => {
          console.log(errors); // Errors
        });      
    },
    UploadLogo(id){
        this.logouploadstatus='loading';
        let formData = new FormData();
        formData.append('fileToUpload', this.logofile);
        formData.append('file', 'logo');
        formData.append('id', id);
        formData.append('user', this.$store.state.token);
        formData.append('action', 'sync_public_file');       

        this.axios.post('wallbox/settings.php',

            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => {
          if(response.data.status=='ok'){
            this.logouploadstatus = 'done';
            if(this.pa_logo=='')
              this.pa_logo = './download/logo_'+this.pa_id+'.'+this.logofiletype;
            let img = document.getElementById("logoimgid");
            img.src='https://'+this.$store.state.WbIp+'/wallbox'+this.pa_logo.substring(1)+'?v='+Math.random();
          }else{
            this.logouploadstatus = 'ready';
          }
        })
        .catch((errors) => {
                  console.log(errors); // Errors
        });
      },
      UploadBack(id){
        this.backuploadstatus='loading';
        let formData = new FormData();
        formData.append('fileToUpload', this.backfile);
        formData.append('file', 'background');
        formData.append('id', id);
        formData.append('user', this.$store.state.token);
        formData.append('action', 'sync_public_file');       

        this.axios.post('wallbox/settings.php',

            formData,
            {
            headers: {
                'Content-Type': 'multipart/form-data'
                }
            }
        ).then((response) => {
          if(response.data.status=='ok'){
            this.backuploadstatus = 'done';
            if(this.pa_background=='')
              this.pa_background = './download/background_'+this.pa_id+'.'+this.backfiletype;
            console.log(this.pa_background);
            let img = document.getElementById("backimgid");
            img.src='https://'+this.$store.state.WbIp+'/wallbox'+this.pa_background.substring(1)+'?v='+Math.random();
            console.log(img.src);
          }else{
            this.backuploadstatus = 'ready';
          }
        })
        .catch((errors) => {
                  console.log(errors); // Errors
        });
      },
      delPubAccess(id){
        this.axios
        .get('wallbox/settings.php?action=sync_public_access_delete&user='+this.$store.state.token+'&id='+id)
        .then((response) => {     
                    if(response.data.status=='ok'){
                      window.location.reload();
                    }else{
                      console.log('Error delete Public Access');                   
                    }
                  })
        .catch((errors) => {
          console.log(errors); // Errors
        });
      },
      addPubAccess(){
        this.axios
        .get('wallbox/settings.php?action=sync_public_access&user='+this.$store.state.token+'&headline=Übersicht der Ladestationen&schema=bright&id=-1')
        .then((response) => {     
                    if(response.data.status=='ok'){
                      window.location.reload();
                    }else{
                      console.log('Error add Public Access');                   
                    }
                  })
        .catch((errors) => {
          console.log(errors); // Errors
        });        
      },
      LogoFileUpload(){
        this.logofile = this.$refs.logofile.files[0];
        if(this.logofile.type=='image/svg+xml')
          this.logofiletype = 'svg';
        if(this.logofile.type=='image/png')
          this.logofiletype = 'png'; 
        if(this.logofile.type=='image/jpeg')
          this.logofiletype = 'jpg';       
        this.logofilename = this.logofile.name;
        this.logofilesize = ((this.logofile.size)/1000).toFixed(2);
        this.logofiledate = this.$dayjs(this.logofile.lastModified).format('DD.MM.YYYY HH:mm');
      },
      BackFileUpload(){
        this.backfile = this.$refs.backfile.files[0];
        if(this.backfile.type=='image/svg+xml')
          this.backfiletype = 'svg';
        if(this.backfile.type=='image/png')
          this.backfiletype = 'png'; 
        if(this.backfile.type=='image/jpeg')
          this.backfiletype = 'jpg'; 
        this.backfilename = this.backfile.name;
        this.backfilesize = ((this.backfile.size)/1000).toFixed(2);
        this.backfiledate = this.$dayjs(this.backfile.lastModified).format('DD.MM.YYYY HH:mm');
      },
      pa_confirm() {
        let eu_pa_headline = encodeURIComponent(this.pa_headline);
        this.axios
        .get('wallbox/settings.php?action=sync_public_access&user='+this.$store.state.token+'&headline='+eu_pa_headline+'&schema='+this.pa_schema+'&id='+this.pa_id)
        .then((response) => {        
                    if(response.data.status=='ok'){
                      this.pa_modalshow = false;
                      window.location.reload();
                    }else{
                      console.log('Error get Public Access Table');                   
                    }
                  })
        .catch((errors) => {
          console.log(errors); // Errors
        });

    },
    cancel(close) {
      // some code...
      close()
    }
  },
  created() {  
        this.isLoading = true;
        this.axios
        .get('wallbox/info.php?action=get_puplic_access&user='+this.$store.state.token)
        .then((response) => {
                    console.log(response.data.tbl_public_access);
                    if(response.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(response.data.status=='ok'){
                      this.pubAccessTable = response.data.tbl_public_access;
                      console.log(this.pubAccessTable);
                    }else{
                      console.log('Error get Public Access Table');                   
                    }
                  this.isLoading = false;  
                  })
        .catch((errors) => {
          this.isLoading = false;
          console.log(errors); // Errors
        });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

svg.spinner {
  animation: 2s linear infinite svg-animation;
  max-width: 100px;
}

@keyframes svg-animation {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
}

circle {
  animation: 1.4s ease-in-out infinite both circle-animation;
  display: block;
  fill: transparent;
  stroke: rgb(var(--color-b-list-text-base));
  stroke-linecap: round;
  stroke-dasharray: 283;
  stroke-dashoffset: 280;
  stroke-width: 10px;
  transform-origin: 50% 50%;
}

@keyframes circle-animation {
  0%,
  25% {
    stroke-dashoffset: 280;
    transform: rotate(0);
  }
  
  50%,
  75% {
    stroke-dashoffset: 75;
    transform: rotate(45deg);
  }
  
  100% {
    stroke-dashoffset: 280;
    transform: rotate(360deg);
  }
}
</style>
